import type { JSX } from "react";

import { cx } from "class-variance-authority";

import * as theme from "./theme.css";

interface ConditionalDisplayProps {
    displayed: boolean;
    children: JSX.Element;
}

/**
 *
 * An alternative to ConditionalRender that still mounts the element, but triggers its display.
 *
 * Injects "display: none" in the "style" property when relevant
 *
 */
export function ConditionalDisplay({
    children,
    displayed,
}: ConditionalDisplayProps): JSX.Element {
    const classes = cx(!displayed && theme.displayNone);
    return <div className={classes}>{children}</div>;
}
